import React, { useContext, useEffect, useState } from "react";
import MessageTextBox from "./text-box";
import CommunityMessageList from "./list";
import CommunityChannel from "./channel";
import ExpandCollaps from "./expand-collaps";
import { useSelector } from "react-redux";
import {
  Link,
  Box,
  Typography,
  Button,
  Modal,
  Fade,
  Backdrop,
  Slide,
  List,
  ListItem,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "548px",
    background: "#fff",
    borderRadius: "8px",
    padding: "30px 15px",
    "& p": {
      fontSize: "16px",
      fontWeight: "500",
      color: "#404040",
      width: "100%",
      linHeight: "24px",
      textAlign: "center",
      marginBottom: "33px",
    },
  },
  popupTitle: {
    paddingBottom: "16px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
    fontSize: "20px",
    fontWeight: "600",
    color: "#000",
    width: "100%",
    marginBottom: "8px",
  },
  btnClose: {
    position: "absolute",
    display: "inline-block",
    top: "25px",
    right: "10px",
    cursor: "pointer",
  },
  btnSearch: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    top: "22px",
    right: "50px",
    height: "38px",
    cursor: "pointer",
  },
  inputContainer: {
    position: "relative",
    display: "block",
    overflow: "hidden",
    marginRight: "10px",
    "& input": {
      fontSize: "14px",
    },
  },
  contentContainer: {
    position: "relative",
    display: "block",
    marginTop: "29px",
    textAlign: "center",
    "& img": {
      marginBottom: "11px",
    },
    "& h4": {
      fontSize: "24px",
      fontWeight: "600",
      color: "#000",
      textAlign: "center",
      marginBottom: "11px",
    },
  },
  btnCreateThread: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontSize: "16px",
    fontWeight: "600",
    width: "100%",
    maxWidth: "180px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "8px",
    height: "44px",
    margin: "0 auto",
    color: "#fff !important",
    textDecoration: "none",
    textTransform: "capitalize !important",
  },
  threadList: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0",
    marginBottom: "60px",
    maxHeight: "250px",
    overflow: "auto",
    "& > li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 0",
      background: "#F4F5FD",
      borderRadius: "8px",
      marginBottom: "16px",
      overflow:"hidden",
    },
  },
  threadTitle: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: "7px",
    width: "100%",
    "& img": {
      margin: "0",
    },
    "& h5": {
      fontSize: "14px",
      fontWeight: "600",
      margin: "0 12px 0 5px",
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#E14084",
    },
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      alignItems: "start",
      "& h5": {
        maxWidth: "84%",
        wordBreak: "break-word",
      },
      "& span": {
        paddingLeft: "15px",
        marginTop: "7px",
      },
    },
  },
  threadCreatedBy: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    "& img": {
      margin: "0",
    },
    "& h5": {
      fontSize: "12px",
      fontWeight: "600",
      margin: "0 12px 0 5px",
    },
    "& span": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#707174",
      margin: "0 12px 0 0",
    },
    "@media(max-width:767px)": {
      flexWrap: "wrap",
      paddingLeft: "30px",
      wordBreak: "break-word",
      "& h5": {
        marginTop: "7px",
      },
      "& span": {
        marginTop: "7px",
      },
    },
    "@media(max-width:480px)": {
      paddingLeft: "0",
      "& h5": {
        marginLeft: "0",
      },
    },
  },
  thumbListContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  thumbList: {
    position: "relative",
    display: "flex",
    width: "100%",
    margin: "0",
    padding: "0",
    "& > li": {
      position: "relative",
      display: "block",
      alignItems: "center",
      marginBottom: "0",
      padding: "0",
      marginLeft: "-8px",
      "& img": {
        margin: "0",
      },
    },
  },
}));
const CommunityMessage = ({
  user,
  collaps,
  setCollaps,
  isMobile,
  goTo,
  community,
  channel,
}) => {
  const classes = useStyles();
  const [fade, availableThreadShow] = useState(false);
  const availableThreadPopupClose = () => availableThreadShow(false);

  const [inputShow, inputShowState] = useState(false);
  const showInput = () => {
    inputShowState((prev) => !prev);
  };
  return (
    <div
      className={isMobile ? `community_message mobile` : `community_message`}
    >
      {!isMobile && <ExpandCollaps setCollaps={setCollaps} collaps={collaps} />}
      <CommunityChannel
        isMobile={isMobile}
        community={community}
        channel={channel}
        goTo={goTo}
      />
      <CommunityMessageList
        user={user}
        isMobile={isMobile}
        community={community}
        channel={channel}
        goTo={goTo}
      />
      <MessageTextBox />
    </div>
  );
};
export default CommunityMessage;
